
import EventEmitter from "events"
import { v4 as uuidv4 } from 'uuid'
import gsap from 'gsap'

class Message {

	constructor( message, isError, index, parent, id ) {

		this.id = id
		this.targetY = 0
		this.index = index
		this.parent = parent
		this.position = index
		this.isError = isError
		this.message = message
		this.element = document.createElement( "div" )
		this.element.style.bottom = `${10 + this.parent.base}px`
		this.element.classList.add( "dashboard_notification" )
		if ( isError ) this.element.classList.add( "error" )
		let svgContent = isError ? `
			<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.9">
                    <path d="M12.8125 12.8125L7.1875 7.1875M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z" stroke="#FF5858" stroke-width="2" stroke-linecap="round"/>
                </g>
            </svg>` : `
			
			<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M12.6183 8.31916L9.0625 11.875L7.85041 10.6629M10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5Z" stroke="#4ef94e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			</svg>
			
		`

		this.element.innerHTML = `

			<div class="dashboard_notification_header">
				${svgContent}
				<p>${isError ? "Error" : "Success"} Notification!</p>
				<button class="close_button">X</button>
			</div>
			<div class="loader_bar"></div>
			<p>${message}</p>
		
		`
		this.closeButton = this.element.querySelector( ".close_button" )
		this.destroy = this.destroy.bind( this )
		gsap.fromTo( this.element, { x: 400 }, { x: 0, ease: "expo.out" } )
		this.destroyTween = gsap.to( this.element.querySelector( '.loader_bar' ), { scaleX: 0, duration: 8, onComplete: this.destroy } )

		this.closeButton.addEventListener( "click", this.destroy )

	}

	destroy() {

		if ( this.destroyTween ) this.destroyTween.kill()
		let cb = () => {

			this.element.remove()
			this.parent.remove( this, this.id )

		}

		gsap.to( this.element, { x: 400, onComplete: cb, ease: "expo.in" } )
		this.closeButton.removeEventListener( "click", this.destroy )

	}

	bringDown() {

		console.log( "BRING DOWN" )
		this.targetY += 88
		gsap.to( this.element, { y: this.targetY, ease: "expo.out" } )

	}

}

export default class NotificationSystemController extends EventEmitter {

	constructor( container, dashboard ) {

		super()

		this.DOM = {}
		this.DOM.container = container
		this.count = 0
		this.base = 0

		this.dashboard = dashboard
		this.onTriggerError = this.onTriggerError.bind( this )
		this.onTriggerSuccess = this.onTriggerSuccess.bind( this )

		this.messages = []

	}

	remove( message, id ) {

		let index, elementsToBringDown
		this.base -= 88
		index = this.messages.indexOf( message )
		elementsToBringDown = this.messages.slice( index, this.messages.length )
		this.messages.splice( index, 1 )

		elementsToBringDown.forEach( element => element.bringDown() )

	}

	onTriggerError( err ) {

		let id = uuidv4()
		let message
		this.count ++
		message = new Message( err, true, this.count, this, id )
		this.messages.push( message )
		this.DOM.container.append( message.element )
		this.base += 88

	}

	onTriggerSuccess( succ ) {
        console.log(succ)
		let id = uuidv4()
		let message
		this.count ++
		message = new Message( succ, false, this.count, this, id )
		this.messages.push( message )
		this.DOM.container.append( message.element )
		this.base += 88

	}


	addEventListeners() {



	}

	removeEventListeners() {



	}

	init() {

		this.addEventListeners()

	}

	destroy() {

		this.removeEventListeners()

	}

}
